const ActionType = require("action-types/snackbar");

exports.messageSnackbar = message => {
    return {
        type: ActionType.SNACKBAR_MESSAGE,
        payload: { message }
    };
};

exports.hideSnackbar = () => {
    return {
        type: ActionType.SNACKBAR_HIDE
    };
};



// WEBPACK FOOTER //
// ./src/actions/snackbar.js